/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endpoint_Cost_RequestsInputs */

const en_endpoint_cost_requests = /** @type {(inputs: Endpoint_Cost_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`requests`)
};

const zh_hans1_endpoint_cost_requests = /** @type {(inputs: Endpoint_Cost_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次请求`)
};

const pt_br2_endpoint_cost_requests = /** @type {(inputs: Endpoint_Cost_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`requisições`)
};

const es_endpoint_cost_requests = /** @type {(inputs: Endpoint_Cost_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`solicitudes`)
};

const fr_endpoint_cost_requests = /** @type {(inputs: Endpoint_Cost_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`requêtes`)
};

const de_endpoint_cost_requests = /** @type {(inputs: Endpoint_Cost_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anfragen`)
};

const ru_endpoint_cost_requests = /** @type {(inputs: Endpoint_Cost_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`запросов`)
};

const it_endpoint_cost_requests = /** @type {(inputs: Endpoint_Cost_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`richieste`)
};

/**
* | output |
* | --- |
* | "requests" |
*
* @param {Endpoint_Cost_RequestsInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_cost_requests = /** @type {((inputs?: Endpoint_Cost_RequestsInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Cost_RequestsInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_cost_requests(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_cost_requests(inputs)
	if (locale === "es") return es_endpoint_cost_requests(inputs)
	if (locale === "fr") return fr_endpoint_cost_requests(inputs)
	if (locale === "de") return de_endpoint_cost_requests(inputs)
	if (locale === "ru") return ru_endpoint_cost_requests(inputs)
	if (locale === "it") return it_endpoint_cost_requests(inputs)
	return en_endpoint_cost_requests(inputs)
});